import React from 'react';
import { TzamunAiMark } from '../TzamunAiBrand';

/**
 * The TzamunAI mark, wearing the react-icons contract (`size` in px +
 * `className`) so it can be dropped into any slot that renders `<Icon size={18} />`
 * — nav menus, badges, buttons. Same adapter idea as ui/Riyal.
 *
 * Exists because the Smart Assistant is not a microphone: voice is one way in,
 * not the product. The nav entry now carries the brand it opens.
 */
export default function TzamunAiIcon({ className = '', size = 18 }) {
  return (
    <TzamunAiMark
      variant="color"
      className={`inline-block shrink-0 ${className}`}
      style={{ height: size, width: size, objectFit: 'contain' }}
    />
  );
}
